/*
 * COPYRIGHT MOTOROLA SOLUTIONS, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

/**
 * Pendo Analytics Event Types and Payloads
 */

export enum PendoEventType {
    RoleChange = 'role_changed',
    AcdStatusChange = 'acd_status_changed',
    CallAction = 'call_action'
}

export enum TriggerType {
    Manual = 'manual',
    Automatic = 'automatic'
}

export enum CallActionType {
    Initiate = 'initiate',
    Answer = 'answer',
    Release = 'release'
}

export enum CallDirection {
    Inbound = 'inbound',
    Outbound = 'outbound',
    Internal = 'internal',
    Conference = 'conference',
    Unknown = 'unknown'
}

export interface BasePendoPayload {
    readonly trigger_type: TriggerType;
}

export interface RoleChangePayload extends BasePendoPayload {
    readonly previous_role: string;
    readonly new_role: string;
}

export interface AcdStatusPayload extends BasePendoPayload {
    readonly acd_status: string;
    readonly reason?: string;
}

export interface CallActionPayload extends BasePendoPayload {
    readonly action: CallActionType;
    readonly call_id?: string;
    readonly call_direction: CallDirection;
}

/**
 * Type-safe mapping: ensures correct payload type for each event
 * To add new event:
 * 1. Add to PendoEventType enum
 * 2. Create new payload interface extending BasePendoPayload
 * 3. Add mapping here
 */
export interface PendoEventPayloadMap {
    [PendoEventType.RoleChange]: RoleChangePayload;
    [PendoEventType.AcdStatusChange]: AcdStatusPayload;
    [PendoEventType.CallAction]: CallActionPayload;
}
